import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import ReCAPTCHA from "react-google-recaptcha";
import "./contact.css";

const ContactForm: React.FC = () => {
  const [email, setEmail] = useState("");
  const [telefon, setTelefon] = useState("");
  const [uzenet, setUzenet] = useState("");
  const [nev, setNev] = useState("");
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState("");
  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // 🔹 új flag
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  useEffect(() => {
    const faders = document.querySelectorAll(".fade-in");
    const appearOptions = { threshold: 0.2, rootMargin: "0px 0px -200px 0px" };
    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("show");
        observer.unobserve(entry.target);
      });
    }, appearOptions);
    faders.forEach((fader, index) => {
      const el = fader as HTMLElement;
      el.style.transitionDelay = `${index * 0.03}s`;
      appearOnScroll.observe(el);
    });
  }, []);

  const pdf = () => {
    window.open("./Privacy Statement.pdf");
  };

  const handleCheckboxChange = () => {
    setAccepted(!accepted);
    setError("");
  };

  const handleRecaptchaChange = (value: any) => {
    setIsRecaptchaVerified(!!value);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (isSubmitting) return; // ha már folyamatban van, ne fusson újra

    if (!accepted) {
      setError("You must accept the privacy policy!");
      return;
    }

    if (!isRecaptchaVerified) {
      Swal.fire({
        icon: "error",
        title: "Please confirm you are not a robot!",
        confirmButtonColor: "#0A8F9A",
      });
      return;
    }

    if (!nev || !email || !telefon || !uzenet) {
      Swal.fire({
        icon: "error",
        title: "Missing information",
        text: "Please fill out all fields!",
        confirmButtonColor: "#0A8F9A",
      });
      return;
    }

    setIsSubmitting(true); // 🔹 letiltjuk a gombot

    try {
      const response = await fetch(
        "https://g38eq5fk5j.execute-api.ap-southeast-2.amazonaws.com/Live/mail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
          body: JSON.stringify({ nev, email, telefon, uzenet }),
        }
      );

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Your message has been sent successfully!",
          confirmButtonColor: "#0A8F9A",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to send the message.",
          confirmButtonColor: "#0A8F9A",
        });
      }
    } catch (error) {
      console.error("An error occurred during submission:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong, please try again later.",
        confirmButtonColor: "#0A8F9A",
      });
    } finally {
      // ürítjük a mezőket, de a gomb marad disabled
      setEmail("");
      setTelefon("");
      setUzenet("");
      setNev("");
      setAccepted(false);
      // setIsRecaptchaVerified(false);

      // if (recaptchaRef.current) {
      //   recaptchaRef.current.reset();
      // }
      // 🔹 visszakapcsoljuk a gombot, hogy újra lehessen küldeni
      setIsSubmitting(false);
    }
      
    
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <h2 className="contact-title fade-in">Contact Us</h2>

        <div className="contact-card fade-in">
          <div className="contact-left">
            <form className="contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Name"
                value={nev}
                onChange={(e) => setNev(e.target.value)}
                className="input-field fade-in"
              />
              <input
                type="email"
                placeholder="E-mail address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field fade-in"
              />
              <input
                type="text"
                placeholder="Phone number"
                value={telefon}
                onChange={(e) => setTelefon(e.target.value)}
                className="input-field fade-in"
              />
              <textarea
                placeholder="Message"
                value={uzenet}
                onChange={(e) => setUzenet(e.target.value)}
                className="textarea-field fade-in"
              ></textarea>

            <div className="policy-consent fade-in">
                <label>
                  <input
                    type="checkbox"
                    checked={accepted}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <a onClick={pdf} className="policy-link">
                    Privacy Policy
                  </a>
                </label>
                {error && <p className="error-text">{error}</p>}
              </div>

              <div className="recaptcha-wrapper fade-in">
                <div className="recaptcha-inner">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6LeXouwrAAAAAFMp6hhc6NM8CBdzJfVLtp6mlfmw"
                    hl="en"
                    onChange={handleRecaptchaChange}
                  />
                </div>
              </div>


                <button
                  type="submit"
                  className={`submit-btn fade-in  "sending-btn" : ""}`}
                 style={{
                  width: "150px",       // fix szélesség
                  height: "60px",       // fix magasság
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  whiteSpace: "nowrap", // fontos! ne törjön sorba a szöveg
                   backgroundColor: isSubmitting ? "#ccc" : "#00bfff",
                  
                }}
                >
                  <span style={{ display: "inline-block", textAlign: "center" }}>
                    {isSubmitting ? "Sending..." : "Send"}
                  </span>
                </button>


            </form>
          </div>

          <div className="contact-right">
            <img src="laptop.png" alt="Contact" className="form-image fade-in" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
